export default __webpack_public_path__ + "static/media/client-logo-4.061502e2.png";